const PATH_SEP = '/';

const splitPath = (path: string) => path.split(PATH_SEP).filter(Boolean);

const matchParts = (as: string[], bs: string[]) => !as.some((a, i) => a !== bs[i]);

/**
 * Check if a path `a` and path `b` are the same route. If `allowChildren` is set, check if `a` is
 * equal to or a parent of `b`.
 */
export function matchPaths(a: string, b: string, allowChildren = false): boolean {
  const aParts = splitPath(a);
  const bParts = splitPath(b);

  if (allowChildren) {
    return aParts.length <= bParts.length && matchParts(aParts, bParts);
  }

  return aParts.length === bParts.length && matchParts(aParts, bParts);
}
